"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiToggle = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
function UiToggle({ items, value, onChangeValue }) {
    const activeIndex = items.indexOf(items.find(item => item.value === value));
    return (react_1.default.createElement(__1.UiBox, { overflowAuto: true, className: clsx_1.default('UiToggle') },
        react_1.default.createElement(__1.UiFlex, { className: "content", flexChildren: true },
            react_1.default.createElement(__1.UiButton, { className: clsx_1.default('indicator', `buttons-${items.length}`, `active-${activeIndex}`) }),
            items.map(({ label, value: buttonValue }) => (react_1.default.createElement(__1.UiButton, { className: clsx_1.default(buttonValue === value && 'active'), onClick: () => onChangeValue(buttonValue), color: buttonValue === value ? 'primary' : 'default', key: buttonValue }, label))))));
}
exports.UiToggle = UiToggle;
